// extracted by mini-css-extract-plugin
export default {"container":"TableAssignmentPanel_container__s-uYX"};